import { API_URL, PL_UPGRADE_HEADER, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const exportAllergensPDF = async (menuId: string, showPotentialAllergens: boolean): Promise<void> => {
  const uri = `${API_URL}/menus/${menuId}/allergens/export`;

  const res = await fetch(uri, {
    method: 'POST',
    body: JSON.stringify({ type: 'PDF', show_potential_allergens: showPotentialAllergens }),
    headers: {
      'Content-Type': 'application/json',
      [PL_UPGRADE_HEADER]: 'true',
    },
  });

  if (!res.ok && res.status !== Status.NO_CONTENT) {
    throw new Error('There has been an error while generating a PDF');
  }
};
